import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const MiniTileContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 312px;
  height: 168px;
`;

export const Title = styled.h3`
  color: ${colours.elexonBlue};
  font-size: ${fonts.xLarge};
`;

export const Text = styled.p`
  color: ${colours.darkGrey};
  margin: 0;
  width: 75%;
  text-align: center;
`;
